// src/components/ContactForm.js
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState(""); // "success" or "error"

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_5hdoniu",
        "template_szfumk8",
        form.current,
        "yxT3AEYtbLLp9TRdF"
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatusMessage("✅ Message sent successfully!");
          setStatusType("success");
          form.current.reset();
        },
        (error) => {
          console.error(error.text);
          setStatusMessage("❌ Oops! Something went wrong. Please try again.");
          setStatusType("error");
        }
      );
  };

  return (
    <div className="bg-gray-900 text-white py-12 sm:py-20 px-6 text-center">
      <h2 className="text-3xl sm:text-4xl font-bold mb-6">Send Us a Message</h2>
      {statusMessage && (
          <div
            className={`mt-4 px-4 py-2 rounded text-sm font-medium ${
              statusType === "success"
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {statusMessage}
          </div>
        )}
      <p className="text-lg sm:text-xl max-w-2xl mx-auto mb-8 text-justify">
        We’d love to hear from you. Fill out the form below and our team will get in touch.
      </p>
      
      <form ref={form} onSubmit={sendEmail} className="max-w-2xl mx-auto grid gap-6 text-left">
        <div>
          <label className="block mb-2 text-sm font-semibold">Name</label>
          <input
            type="text"
            name="name"
            required
            className="w-full p-3 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-semibold">Email</label>
          <input
            type="email"
            name="email"
            required
            className="w-full p-3 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-semibold">Message</label>
          <textarea
            name="message"
            required
            rows="5"
            className="w-full p-3 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          ></textarea>
        </div>
        <button
          type="submit"
          className="bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded transition"
        >
          Send Message
        </button>

        {/* Status Message */}
        
      </form>
    </div>
  );
};

export default ContactForm;
